{
  "#MDE_BESTELLVORSCHLAG": { },
  "#MDE_INVENTUR": {
    "MODALS": {
      "CONFIRMATION": {
        "TITLE": "Inventur abschließen?",
        "SUBTITLE": "Bestätigung erforderlich",
        "QUESTION": "Sicher, dass Sie die Inventur abschließen wollen?"
      }
    },
    "STEPS": {
      "LAGER": {
        "TITLE": "Lager-Auswahl",
        "DESCRIPTION": "Bitte Lager für die Inventur auswählen!"
      },
      "LAGERPLATZ": {
        "TITLE": "Lagerplatz",
        "DESCRIPTION": "Bitte Lagerplatz eingeben oder scannen!"
      },
      "BELEGDATUM": {
        "TITLE": "Belegdatum",
        "DESCRIPTION": "Bitte gewünschtes Belegdatum eingeben"
      }
    }
  }
}
